import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as selectedItemsActions from '../store/userConfigs/selectedItemsSlice';
import { userConfigsSelectors } from '../store/userConfigs';

class TableSelectionManager extends Component {

  onSelect = (id, isSelect) => {
    const selectedIds = this.props.selectedItems;
    if (isSelect) {
      this.props.setSelection(
        [...selectedIds, id],
        this.props.objectName
      );
    } else {
      this.props.setSelection(
        selectedIds.filter((i) => i !== id),
        this.props.objectName
      );
    }
  };

  onSelectAll = (ids, isSelect) => {
    const selectedIds = this.props.selectedItems;
    if (isSelect) {
      this.props.setSelection(
        [...selectedIds, ...ids],
        this.props.objectName
      );
    } else {
      this.props.setSelection(
        selectedIds.filter((id) => !ids.includes(id)),
        this.props.objectName
      );
    }
  };

  render() {
    return React.Children.map(this.props.children, child => React.cloneElement(child, {
      onSelect: this.onSelect,
      onSelectAll: this.onSelectAll,
      selected: this.props.selectedItems,
    }));
  }
}

const actionCreators = {
  setSelection: selectedItemsActions.setSelection,
  clearSelection: selectedItemsActions.clearSelection,
};

const mapStateToProps = (state, ownProps) => ({
  selectedItems: userConfigsSelectors.selectedItems(state, ownProps.objectName),
});

export default connect(mapStateToProps, actionCreators)(TableSelectionManager);



// WEBPACK FOOTER //
// ./src/components/tableSelectionManager.js